import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import 'react-datetime/css/react-datetime.css';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { SubMessage } from '../DTCopyTextSendMacro.styles';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import {
  Container,
  DateText,
  SelectedText,
} from '../DTChangeShippingDateThenSendMacroNode/DTChangeShippingDateThenSendMacroNode.styles';
import CustomDateTimePicker from 'components/common/CustomDateTimePicker/CustomDateTimePicker';
import { getDecisionNodeAtPath, getRbiCustomerId, getSimplrAccountIdOfSelectedTicket } from 'extractFromState';
import { rbiUpdateCustomerBirthday } from 'actions/tools/RBIActions';
import { addNoteToSelectedTicket } from 'actions';

const DTRBIUpdateCustomerBirthdayThenSendMacroNode = () => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const customerId = useSelector(getRbiCustomerId);
  /**
   * NOTE(azdoolittle|SPD-10790|2024-09-25):
   * RBI ToS require a minimum of 13 years old.
   * 80% of RBI customers are under 30
   */
  const minimumAge = parseInt(decisionNode.minimumAge) || 13;
  const thirtyYearsAgo = moment().subtract(30, 'years');
  const maxEligibleBirthday = moment().subtract(13, 'years');
  const maxEligibleBirthdaySpelledOut = maxEligibleBirthday.format('MMMM Do, YYYY');
  const confirmationDate = selectedDate
    ? `${selectedDate.format('MM/DD/YYYY')} (${selectedDate.format('MMM Do, YYYY')})`
    : '';

  const checkEligibleDate = useCallback(
    (dateFromPicker) => {
      const todaysDate = moment();
      const customerAge = todaysDate.diff(dateFromPicker, 'years');
      const isMinimumAge = customerAge >= minimumAge;

      return isMinimumAge;
    },
    [minimumAge]
  );

  const updateBirthday = async () => {
    const params = {
      simplrAccountId,
      customerId,
      // NOTE(azdoolittle|SPD-10790|2024-09-25): RBI expects date in YYYY-MM-DD format
      birthday: selectedDate.format('YYYY-MM-DD'),
    };

    dispatch(rbiUpdateCustomerBirthday(params));
  };

  const createUpdateBirthdayNote = () => {
    return `Customer birthday updated to ${selectedDate.format('MM/DD/YYYY')}`;
  };

  const handleNextButtonClick = async () => {
    await updateBirthday();
    dispatch(addNoteToSelectedTicket(createUpdateBirthdayNote()));
  };

  return (
    <DTCopyTextSendMacroView
      buttonText={`NEXT`}
      onNextButtonClick={handleNextButtonClick}
      disableActionButton={!selectedDate}
      hideCopyText={false}
      popupConfirmationText={`You are about to update this customer's birthday as ${confirmationDate}.`}
      customErrorMessage={'Error updating customer birthday'}
    >
      <Container>
        <SubMessage>
          Select year of birth, then month, then day and click 'NEXT' to update customer's birthday.
        </SubMessage>
        <SubMessage>
          Note: The minimum customer age is 13. Customer should be born on {maxEligibleBirthdaySpelledOut} or earlier.
        </SubMessage>
        {selectedDate && (
          <SelectedText>
            Updated birthday is set to:
            <DateText>{confirmationDate}</DateText>
          </SelectedText>
        )}
        <CustomDateTimePicker
          initialViewMode={'years'}
          initialViewDate={thirtyYearsAgo}
          input={false}
          isValidDate={checkEligibleDate}
          minDate={maxEligibleBirthday}
          onChange={(date) => setSelectedDate(date)}
          timeFormat={false}
          value={selectedDate}
        />
      </Container>
    </DTCopyTextSendMacroView>
  );
};

export default withConfirmation(DTRBIUpdateCustomerBirthdayThenSendMacroNode);
